module.exports = __webpack_public_path__ + "img/google-icon.0dd54f85.png";